<template>
    <div class="bg-white rounded-lg w-full pb-10  border-snow- shadow-sm">
        <div class="px-6 pb-3">
            <div class="flex items-center justify-between py-8 ">
                <h3 class="text-xl font-semibold text-purple-dark">
                    ₦ {{ (transaction_details ? transaction_details.amount : 0) | formatAmount }}
                </h3>
                <p class="text-smoke-dark text-xs">Rate: {{ active_country.currency_rate_to_usd || 0 }}/$</p>
            </div>
            <div>
                <p class="text-sm text-smoke-dark ">Make Payment wIth:</p>
            </div>
        </div>
        <div class="flex items-center md:flex-row flex-col">
            <div
                :class="
                    `flex h-16 md:w-1/3 w-full flex items-center md:justify-center px-4 cursor-pointer duration-500 ${
                        active === method.text ? 'bg-' + method.activeColor + '-pale' : ''
                    }`
                "
                @click="
                    () => {
                        if (method.text !== 'Card') {
                            changeActive(method.text)
                        }
                    }
                "
                v-for="method in payment_methods"
                :key="method.text"
            >
                <div
                    :class="
                        `h-8 w-8 rounded-full ${
                            active === method.text ? 'bg-' + method.activeColor : 'bg-smoke-200'
                        } flex items-center justify-center`
                    "
                    v-html="method.svg"
                ></div>
                <div class="ml-2">
                    <p
                        :class="
                            `${
                                active === method.text ? 'text-' + method.activeColor + '-dark' : 'text-smoke-dark'
                            } text-sm `
                        "
                    >
                        {{ method.text }}
                    </p>
                </div>
            </div>
        </div>
        <div class="mt-5">
            <template v-if="!voucher_pay">
                <template v-if="active === 'Bitcoin'">
                    <bitcoin-pay @set-type="setDepositType('btc')" :type="details.deposit_type" :payload="payload" />
                </template>
                <template v-else-if="active === 'Bank'">
                    <bank-pay
                        @set-type="setDepositType('bank')"
                        :type="details.deposit_type"
                        :payload="payload"
                        :amount="payload.data ? payload.data.amount : 0"
                    />
                </template>
                <template v-else-if="active === 'Card'">
                    <card-pay @set-type="setDepositType('card')" :type="details.deposit_type" :payload="payload" />
                </template>
            </template>
            <template v-else>
                <div class="bg-snow-300 rounded-lg px-5 py-4 relative mb-24 w-10/12 mx-auto">
                    <template v-if="initate_transaction_sec !== 0">
                        <p class="font-medium text-base text-purple-dark text-center">
                            Your transaction would be initialized in {{ initate_transaction_sec }}s
                        </p>

                        <button class="text-sm text-center text-red mt-8 w-full" @click="cancel">Cancel</button>
                    </template>
                    <template v-else>
                        <p class="font-medium text-base text-purple-dark text-center">
                            Transaction initialized with voucher
                        </p>
                    </template>
                </div>
            </template>
            <div class="flex flex-col items-center justify-between px-6">
                <div class="flex items-center">
                    <button
                        @click="validatePayment"
                        class="py-4 px-8 rounded-lg bg-orange text-white text-base font-semibold"
                        :disabled="!Object.entries(payload).length || error"
                    >
                        Validate Payment
                    </button>
                    <button
                        @click="$emit('go-back')"
                        class="py-4 px-4 ml-2 rounded-lg bg-orange-pale text-orange text-base font-semibold"
                        :disabled="Object.entries(payload).length || error"
                    >
                        Go Back
                    </button>
                </div>
                <div class="mt-4">
                    <p class="text-smoke-dark text-xs">Time left:</p>
                    <div class="flex items-center">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            class="mr-1"
                            fill="#C0CCDA"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.2001 7.2H8.80014V4.8C8.80014 4.3576 8.44174 4 8.00014 4C7.55854 4 7.20014 4.3576 7.20014 4.8V8C7.20014 8.4424 7.55854 8.8 8.00014 8.8H11.2001C11.6425 8.8 12.0001 8.4424 12.0001 8C12.0001 7.5576 11.6425 7.2 11.2001 7.2ZM7.99972 14.4C4.47092 14.4 1.59972 11.5288 1.59972 8C1.59972 4.4712 4.47092 1.6 7.99972 1.6C11.5285 1.6 14.3997 4.4712 14.3997 8C14.3997 11.5288 11.5285 14.4 7.99972 14.4ZM8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0Z"
                            />
                        </svg>

                        <p class="text-grey-300 text-sm mt-1">
                            {{ minutes | getDoubleDigit }}:{{ seconds | getDoubleDigit }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BitcoinPay from './BitcoinPay'
import BankPay from './BankPay'
import CardPay from './CardPay'
import { formatAmount } from '@/util/formatAmount'
import { mapGetters, mapActions } from 'vuex'
import countdown from '@/util/countdown'
export default {
    components: {
        BitcoinPay,
        BankPay,
        CardPay,
    },
    data() {
        return {
            active: 'Bitcoin',
            details: {},
            payment_methods: [
                {
                    text: 'Bitcoin',
                    activeColor: 'yellow',
                    svg: `<svg width="12" height="16" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M7.27477 6.38485C7.04245 6.03831 6.69187 5.80029 6.22306 5.67092C6.82007 5.31966 7.08242 4.72347 7.01039 3.88227C6.98631 3.57723 6.91323 3.31287 6.79097 3.08878C6.66864 2.86465 6.50355 2.68446 6.29507 2.54815C6.08677 2.41167 5.86021 2.30777 5.61594 2.23615C5.3716 2.16452 5.09107 2.11251 4.77455 2.08019V0.333252H3.84914V2.03165C3.68889 2.03165 3.44451 2.03627 3.11601 2.04552V0.333252H2.19047V2.08019C2.05822 2.08483 1.86393 2.08718 1.60753 2.08718L0.333496 2.08019V3.21711H1.00053C1.30503 3.21711 1.48332 3.37427 1.53539 3.68849V5.67809C1.57551 5.67809 1.60753 5.68047 1.63159 5.68508H1.53539V8.47174C1.50338 8.70738 1.38721 8.82531 1.18686 8.82531H0.519867L0.333538 10.0939H1.5355C1.61163 10.0939 1.72174 10.0951 1.86604 10.0972C2.01025 10.0995 2.11838 10.1007 2.19051 10.1007V11.8684H3.1162V10.1215C3.28443 10.1262 3.52881 10.1285 3.84933 10.1285V11.8684H4.77476V10.1007C5.10336 10.0822 5.39481 10.0478 5.64911 9.99675C5.90353 9.94574 6.14699 9.86615 6.37931 9.75747C6.61161 9.64893 6.8059 9.51367 6.96213 9.35191C7.11844 9.1903 7.24753 8.98454 7.34988 8.73494C7.45188 8.48534 7.51707 8.19649 7.54502 7.86829C7.59733 7.22607 7.50714 6.73152 7.27477 6.38485ZM3.13401 3.29315C3.16207 3.29315 3.24119 3.29199 3.3714 3.28966C3.50168 3.28728 3.60981 3.28499 3.69594 3.28266C3.7821 3.28038 3.89829 3.28616 4.04458 3.30002C4.19081 3.31389 4.31399 3.33241 4.41412 3.35548C4.51426 3.37855 4.62453 3.41669 4.74462 3.46984C4.86492 3.52294 4.96101 3.58768 5.03304 3.66392C5.10522 3.74016 5.1663 3.83726 5.21629 3.95511C5.26643 4.07295 5.29148 4.20812 5.29148 4.3606C5.29148 4.49001 5.27348 4.6079 5.23747 4.71425C5.20152 4.82052 5.14729 4.90951 5.07526 4.98114C5.00321 5.05279 4.92895 5.11524 4.85281 5.16834C4.77676 5.22144 4.67951 5.26423 4.56136 5.29654C4.44323 5.32891 4.34007 5.35433 4.25198 5.37278C4.16383 5.39129 4.05367 5.40403 3.92144 5.41093C3.78919 5.41782 3.68899 5.42253 3.62092 5.42482C3.55278 5.4271 3.45966 5.4271 3.34143 5.42482C3.22317 5.42253 3.15415 5.42132 3.13407 5.42132V3.29313H3.13401V3.29315ZM5.66119 8.01395C5.62303 8.1203 5.57403 8.21279 5.51397 8.29141C5.45381 8.36983 5.37465 8.43923 5.27654 8.49922C5.17845 8.55939 5.0832 8.60783 4.99113 8.64481C4.89893 8.68194 4.78771 8.71411 4.65762 8.74193C4.52724 8.76969 4.41313 8.78921 4.31488 8.80084C4.21676 8.81242 4.09963 8.82162 3.96335 8.82861C3.82718 8.83541 3.72095 8.83893 3.64485 8.83893C3.56872 8.83893 3.47254 8.83767 3.35635 8.83541C3.2401 8.83325 3.16604 8.83209 3.13397 8.83209V6.48889C3.16598 6.48889 3.26115 6.48663 3.41944 6.48192C3.57775 6.47726 3.70689 6.4751 3.80706 6.4751C3.90721 6.4751 4.04549 6.48192 4.22184 6.49588C4.39802 6.50965 4.54627 6.53036 4.66657 6.55809C4.78672 6.58587 4.91783 6.62855 5.06017 6.68639C5.20236 6.74413 5.3176 6.81459 5.40578 6.89777C5.49393 6.9811 5.56801 7.08724 5.62808 7.21667C5.6883 7.34604 5.71834 7.49396 5.71834 7.66038C5.71832 7.78992 5.69931 7.90758 5.66119 8.01395Z"
                              fill="white"
                          />
                      </svg>`,
                },
                {
                    text: 'Bank',
                    activeColor: 'purple',
                    svg: `<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.4894 9.98926H0.500084C0.22409 9.98926 0.000488281 10.2129 0.000488281 10.4891C0.000488281 10.7648 0.22409 10.9885 0.500084 10.9885H10.4892C10.7652 10.9885 10.9888 10.7648 10.9888 10.4891C10.9886 10.2129 10.765 9.98926 10.4894 9.98926Z" fill="white"/>
                            <path d="M1.12411 8.69036C0.848114 8.69036 0.624512 8.91396 0.624512 9.18995C0.624512 9.46595 0.848114 9.68979 1.12411 9.68979H9.8647C10.1407 9.68979 10.3643 9.46595 10.3643 9.18995C10.3643 8.91396 10.1407 8.69036 9.8647 8.69036H9.74003V4.19493H9.8647C10.0029 4.19493 10.1143 4.08313 10.1143 3.94537C10.1143 3.8076 10.0025 3.6958 9.8647 3.6958H1.12411C0.986111 3.6958 0.874544 3.8076 0.874544 3.94537C0.874544 4.08313 0.986345 4.19493 1.12411 4.19493H1.24901V8.69013H1.12411V8.69036ZM8.74084 4.19493V8.69013H7.24252V4.19493H8.74084ZM6.24333 4.19493V8.69013H4.74501V4.19493H6.24333ZM2.24773 4.19493H3.74605V8.69013H2.24773V4.19493Z" fill="white"/>
                            <path d="M0.499606 3.24632H10.4887C10.4904 3.24632 10.4922 3.24632 10.4936 3.24632C10.7699 3.24632 10.9932 3.02272 10.9932 2.74673C10.9932 2.52733 10.852 2.34139 10.6557 2.27403L5.69952 0.043855C5.56924 -0.0146183 5.42025 -0.0146183 5.28974 0.043855L0.294715 2.29134C0.0797671 2.38817 -0.038349 2.62159 0.0112364 2.85174C0.0605879 3.0819 0.264075 3.24632 0.499606 3.24632Z" fill="white"/>
                          </svg>`,
                },
                {
                    text: 'Card',
                    activeColor: 'green',
                    svg: `<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8002 3.10024H1.20023V2.50024C1.20023 2.16964 1.46903 1.90024 1.80023 1.90024H10.2002C10.5314 1.90024 10.8002 2.16964 10.8002 2.50024V3.10024ZM9.00013 6.69978H7.80013C7.47013 6.69978 7.20013 6.42978 7.20013 6.09978C7.20013 5.76978 7.47013 5.49978 7.80013 5.49978H9.00013C9.33013 5.49978 9.60013 5.76978 9.60013 6.09978C9.60013 6.42978 9.33013 6.69978 9.00013 6.69978ZM5.39994 6.69978H2.99994C2.66994 6.69978 2.39994 6.42978 2.39994 6.09978C2.39994 5.76978 2.66994 5.49978 2.99994 5.49978H5.39994C5.72994 5.49978 5.99994 5.76978 5.99994 6.09978C5.99994 6.42978 5.72994 6.69978 5.39994 6.69978ZM10.2 0.700012H1.8C0.8076 0.700012 0 1.50761 0 2.50001V7.30001C0 8.29241 0.8076 9.10001 1.8 9.10001H10.2C11.1924 9.10001 12 8.29241 12 7.30001V2.50001C12 1.50761 11.1924 0.700012 10.2 0.700012Z" fill="white"/>
                          </svg>`,
                },
            ],

            interval: null,
            minutes: 0,
            seconds: 0,
            initate_transaction_sec: 5,
            voucher_pay: false,
            voucher_interval: null,
        }
    },

    filters: {
        formatAmount: function(val) {
            if (val) {
                return formatAmount(val)
            }
            return 0
        },

        getDoubleDigit(digit) {
            if (parseInt(digit) < 10) {
                return '0' + digit
            } else {
                return digit
            }
        },
    },

    computed: {
        ...mapGetters('Countries', {
            active_country: 'GET_ACTIVE_COUNTRY',
        }),

        ...mapGetters('Voucher', {
            voucher: 'GET_VOUCHER',
        }),
    },

    props: {
        transaction_details: Object,
        payload: Object,
        error: Boolean,
    },

    watch: {
        transaction_details: function(newValue) {
            if (Object.entries(newValue).length) {
                this.minutes = 30
            }
            if (newValue.voucher) {
                this.checkVoucher()
            }
        },

        error: function(newValue) {
            if (newValue) {
                this.undoDepositType()
                this.$forceUpdate()
            }
        },

        payload: function(newValue) {
            if (Object.entries(newValue).length) {
                clearInterval(this.interval)
                this.startCountdown()
            } else {
                clearInterval(this.interval)
                this.minutes = 0
                this.seconds = 0
            }
        },
    },

    methods: {
        changeActive(text) {
            this.active = text
        },

        setDepositType(type) {
            this.details = this.transaction_details
            this.details.deposit_type = type
            this.$emit('initTransaction', this.details)
        },

        undoDepositType() {
            this.details.deposit_type = ''
        },

        startCountdown() {
            let time = new Date().getTime()

            time = time + process.env.VUE_APP_WAIT_TIME * 60000
            this.interval = setInterval(() => {
                const remainingTime = countdown(time)
                if (Object.entries(remainingTime).length) {
                    this.minutes = remainingTime.minutes
                    this.seconds = remainingTime.seconds
                } else {
                    clearInterval(this.interval)
                    this.$router.push('/')
                }
            }, 1000)
        },

        ...mapActions('Transaction', {
            validateTransaction: 'FETCH_TRANSACTION_DETAILS',
        }),

        validatePayment() {
            this.validateTransaction(this.payload.transaction_reference)
        },

        checkVoucher() {
            if (parseFloat(this.voucher.amount) >= parseFloat(this.transaction_details.amount)) {
                this.voucher_pay = true
                this.initializeTransactionWithVoucher()
            }
        },

        initializeTransactionWithVoucher() {
            this.voucher_interval = setInterval(() => {
                if (this.initate_transaction_sec === 1) {
                    this.setDepositType('voucher')

                    clearInterval(this.voucher_interval)
                }
                this.initate_transaction_sec = this.initate_transaction_sec - 1
            }, 1000)
        },

        cancel() {
            clearInterval(this.voucher_interval)
        },
    },
}
</script>

<style lang="scss" scoped>
.skeleton {
    content: ' ';
    width: 250px;
    height: 24px;
    background-color: #ddd;
    margin: 10px 0;
}

@keyframes pulse-bg {
    0% {
        background-color: #ddd;
    }
    50% {
        background-color: #d0d0d0;
    }
    100% {
        background-color: #ddd;
    }
}

button:disabled {
    background: theme('colors.snow.200');
    color: theme('colors.smoke.100');
    cursor: not-allowed;
}
</style>
